var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCutoutLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 66,
    viewBox: "0 0 33 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 33C33 14.7746 18.2254 -6.45818e-07 3.8147e-06 -1.44248e-06L9.29746e-07 66C18.2254 66 33 51.2254 33 33Z",
    fill: "#000F06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutoutLeft);
export default __webpack_public_path__ + "static/media/CutoutLeft.98d3696a79285b364675b609e2218317.svg";
export { ForwardRef as ReactComponent };